﻿window.marker = function () {
    var instance = {
        init: function (id) {
            id = id.toLowerCase();
            var rows = document.getElementById(id).rows;

            for(var i=1; i < rows.length;i++) {                

                var currentRow = rows[i].getElementsByTagName("td");

                if (rows[i + 1]) {

                var nextRow = rows[i + 1].getElementsByTagName("td");
                
                for (let index = 0; index < currentRow.length; index++) {
                    const currentTd = currentRow[index];
                    const nextTd = nextRow[index];                   

                    if (currentTd.dataset.value != nextTd.dataset.value) {
                        nextTd.style.color = "#eb4034";
                    }
                    
                }  
                }
                        
                

            }
        }
       
    };   

    return instance;
}();